function filter(obj) {
  $thisorthat.each(obj, function(key, value){
    if (value === "" || value === null){
      delete obj[key];
    } else if (Object.prototype.toString.call(value) === '[object Object]') {
      filter(value);
    } else if ($thisorthat.isArray(value)) {
      $thisorthat.each(value, function (k,v) { filter(v); });
    }
    return obj
  });
} 

function ping(thisorthat) {   
	var parameters = thisorthat
	$thisorthat.ajax({
		url: thisorthat.url, // route to the controller method
		type: 'POST',
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $thisorthat('meta[name="csrf-token"]').attr('content'))},
		dataType: 'json',
    data: {payload: JSON.stringify(parameters).replace(/null/i, "\"\"")}, // this goes to Controller in params hash, i.e. params[:file_name]
    complete: function() {},
    success: function(data) {
      var parameters = {}
      parameters.cookie_data = "thisorthat-trial=" + data["trial_id"] + "; expires=" + data["trial_expires"]  + "; path=/"
      document.cookie = parameters.cookie_data
      document.cookie = "thisorthat-lockout=1; expires=" + data["lockout_expires"] + "; path=/"
      thisorthat.url = '/apps/thisorthat/proxy/trial'
      var container = $thisorthat('body').append($thisorthat.parseHTML(data.content))
      setTimeout(function(){
        $thisorthat('div.thisorthat-wrap').show()
      }, 50);
      parameters.display = {}
      parameters.display.start = Date.now()
      $thisorthat('div.thisorthat-wrap').click(function(){
        $thisorthat(this).remove()
        parameters.display.end = Date.now()
        $thisorthat.ajax({
          url: thisorthat.url, // route to the controller method
          type: 'POST',
          beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $thisorthat('meta[name="csrf-token"]').attr('content'))},
          dataType: 'json',
          data: {payload: JSON.stringify(parameters).replace(/null/i, "\"\"")}, // this goes to Controller in params hash, i.e. params[:file_name]
          complete: function() {},
          success: function(data) {},
          error: function(xhr, status, error) {}, 
        })
      })           
    },
    error: function(xhr, status, error) { }, 
  })
};

function trial_ping(thisorthat) {  
	var parameters = thisorthat
	$thisorthat.ajax({
		url: thisorthat.url, // route to the controller method
		type: 'POST',
        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $thisorthat('meta[name="csrf-token"]').attr('content'))},
		dataType: 'json',
        data: {payload: JSON.stringify(parameters).replace(/null/i, "\"\"")}, // this goes to Controller in params hash, i.e. params[:file_name]
        complete: function() {},
        success: function(data) {
        },
        error: function(xhr, status, error) { }, 
    })
};


function thisorthatValues(object) {
  var values = [];
  for(var property in object) {
    values.push(object[property]);
  }
  return values;
}

function thisorthatScan() {
  var pairs = document.cookie.split(";");
  var cookies = {};
  for (var i=0; i<pairs.length; i++){
    var pair = pairs[i].split("=");
    cookies[pair[0].trim()] = unescape(pair[1].trim());
  }
  if ( cookies["thisorthat-trial"] == null && cookies["thisorthat-lockout"] == null ) {
    new Fingerprint2().get(function(result, components) {        
      thisorthat.fp.result = result
      thisorthat.fp.user_agent = thisorthatValues(components[0])[1]
      thisorthat.fp.language = thisorthatValues(components[1])[1]
      thisorthat.cart.cart_token = cookies["cart"]
      var shop = $thisorthat('script[id=__st]').text()
      shop = shop.substring(0, shop.indexOf('}')+1)
      shop = shop.substring(shop.indexOf('{'), shop.length)
      shop = JSON.parse(shop)
      thisorthat.shop.id = shop.a
      thisorthat.current_url = window.location.href 
      thisorthat.referral_url = document.referrer  
      thisorthat.url = '/apps/thisorthat/proxy/ping'
      ping(thisorthat)
    });  
  } else if ( cookies["thisorthat-trial"] != null ) {
    thisorthat.cookie_value = cookies["thisorthat-trial"]   
    thisorthat.cart.cart_token = cookies["cart"]
    thisorthat.current_url = window.location.href 
    thisorthat.referral_url = document.referrer
    thisorthat.url = '/apps/thisorthat/proxy/trial'
    trial_ping(thisorthat)
  };    
}; 